import React from 'react';
import NumberFormat from 'react-number-format';
import uniqid from 'uniqid';
import { onChange, validateForm } from './../../utils';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        const detail = props.detail;
        this.state = {
            id: detail ? detail.id : '',
            uid: detail ? detail.uid : uniqid(),
            place: { name: 'place', value: '', error: '', isRequired: true },
            fromDate: { name: 'fromDate', value: '', error: '', isRequired: true },
            toDate: { name: 'toDate', value: '', error: '', isRequired: true },
            noOfDays: { name: 'noOfDays', value: '', error: '', isRequired: true },
            noOfDA: { name: 'noOfDA', value: '', error: '', isRequired: true },
            rate: { name: 'rate', value: '', error: '', isRequired: true },
            amount: { name: 'amount', value: '', error: '', isRequired: true },
            // bills: { name: 'bills', value: [], error: '', isRequired: false },
        }
    }

    render() {
        const { place, fromDate, toDate, noOfDays, noOfDA, rate, amount } = this.state;
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <form onSubmit={this.onSubmit}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Place of stay <small>*</small></label>
                                        <input
                                            type="text"
                                            className={place.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={place.name}
                                            value={place.value}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Stayed from <small>*</small></label>
                                        <input
                                            type="date"
                                            className={fromDate.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={fromDate.name}
                                            value={fromDate.value}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Stayed till <small>*</small></label>
                                        <input
                                            type="date"
                                            className={toDate.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={toDate.name}
                                            value={toDate.value}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Number of Days <small>*</small></label>
                                        <NumberFormat
                                            thousandSeparator={true}
                                            decimalScale={2}
                                            allowNegative={false}
                                            className={noOfDays.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={noOfDays.name}
                                            value={noOfDays.value}
                                            onValueChange={(e: any) => { this.onChange({ target: { name: noOfDays.name, value: e.value } }) }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Number of D.A. <small>*</small></label>
                                        <NumberFormat
                                            thousandSeparator={true}
                                            decimalScale={2}
                                            allowNegative={false}
                                            className={noOfDA.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={noOfDA.name}
                                            value={noOfDA.value}
                                            onValueChange={(e: any) => { this.onChange({ target: { name: noOfDA.name, value: e.value } }) }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Rate <small>*</small></label>
                                        <input
                                            type="text"
                                            className={rate.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={rate.name}
                                            value={rate.value}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Amount <small>*</small></label>
                                        <NumberFormat
                                            decimalScale={2}
                                            thousandSeparator={true}
                                            allowNegative={false}
                                            className={amount.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={amount.name}
                                            value={amount.value}
                                            onValueChange={(e: any) => { this.onChange({ target: { name: amount.name, value: e.value } }) }}
                                        />
                                    </div>
                                </div>

                                {/* <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Bill(s) <sup>(optional)</sup></label>
                                        <input
                                            name={bills.name}
                                            onChange={this.onChange}
                                            type="file"
                                            multiple={true}
                                            className="form-control"
                                            style={{ padding: 4 }}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        {
                                            Array.from(bills.value).map(function (item: any, index: number) {
                                                return (
                                                    <span key={index} className="badge badge-primary mr-1">{item.name}</span>
                                                )
                                            })
                                        }
                                    </div>
                                </div> */}

                                <div className="col-md-3">
                                    <button type="button" onClick={this.props.onCancel} className="btn btn-block cancel-button btn-sm btn-sm">Cancel</button>
                                </div>
                                <div className="col-md-6">
                                    &nbsp;
                                                </div>
                                <div className="col-md-3">
                                    <button type="submit" className="btn btn-block submit-button btn-sm">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }

    onChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;
        onChange(this, name, value);
    }

    onSubmit = (e: any) => {
        e.preventDefault();
        if (validateForm(this)) {
            this.setState({ showLoader: true });
            const st = this.state;
            const model = {
                id: st.id,
                uid: st.uid,
                place: st.place.value,
                fromDate: st.fromDate.value,
                toDate: st.toDate.value,
                noOfDays: st.noOfDays.value,
                noOfDA: st.noOfDA.value,
                rate: parseFloat(st.rate.value),
                amount: parseFloat(st.amount.value),
                // bills: st.bills.value
            };
            if (st.id === "") {
                model.id = new Date().getTime();
            }
            this.props.onSubmit(model);
        }
    }
}

export default ComponentName;